import React, { forwardRef } from "react";
import styles from "./homepage-card.module.scss";

const cssClassName = "homepage-card";
const TITLE_PREFIX = "Things";

export interface HomepageCard {
  id: string;
  color: { r: number; g: number; b: number };
  isTransparent?: boolean;
  image: string;
  title: string;
  description: string;
  onClick: () => void;
}

interface HomepageCardProps {
  card: HomepageCard;
  isDragMode?: boolean; // true = draggable, false = clickable
  handleRef?: (el: Element | null) => void;
}

export const HomepageCard = forwardRef<HTMLButtonElement, HomepageCardProps>(
  ({ card, handleRef, isDragMode = false }, ref) => {
    const {
      color,
      isTransparent = true,
      image,
      title,
      description,
      onClick,
    } = card;

    // Only attach handleRef if drag mode is active
    const setRefs = (el: HTMLButtonElement | null) => {
      if (ref) {
        if (typeof ref === "function") ref(el);
        else ref.current = el;
      }

      if (isDragMode) {
        handleRef?.(el);
      }
    };

    const handleClick = () => {
      if (isDragMode) return;
      onClick();
    };

    return (
      <button
        ref={setRefs}
        className={styles[cssClassName]}
        onClick={handleClick}
        style={{
          backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b}, ${
            isTransparent ? 0.9 : 1
          })`,
          cursor: isDragMode ? "grab" : "pointer",
        }}
      >
        <div className={styles[`${cssClassName}__content`]}>
          <div className={styles[`${cssClassName}__icon`]}>
            <img src={image} alt={title} draggable={false} />
          </div>

          <div className={styles[`${cssClassName}__text-content`]}>
            <h3 className={styles[`${cssClassName}__title`]}>
              <span>{TITLE_PREFIX}</span> <br />
              {title}
            </h3>
            <p className={styles[`${cssClassName}__description`]}>
              {description}
            </p>
          </div>
        </div>
      </button>
    );
  },
);

HomepageCard.displayName = "HomepageCard";
